import { useAppDispatch } from '@/store';
import { flashMessageStore } from '@/store/flashMessage';
import { useCallback } from 'react';

export const useFlashMessenger = () => {
  const dispatch = useAppDispatch();

  const flashNotice = useCallback(
    (message: string) => {
      dispatch(
        flashMessageStore.actions.set({
          body: message,
        }),
      );
    },
    [dispatch],
  );

  const flashError = useCallback(
    (message: string) => {
      dispatch(
        flashMessageStore.actions.set({
          body: message,
          isWarning: true,
        }),
      );
    },
    [dispatch],
  );

  return {
    flashNotice,
    flashError,
  };
};
